export default "__VITE_ASSET___12nrCqB__"